import { bool, number, string } from 'prop-types';

const voucherTypeBasicInformationPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  displayInPaymentsPage: bool,
  description: string,
  voucherCode: string,
};

const voucherTypeBasicInformationDefaultProps = {
  description: null,
  displayInPaymentsPage: null,
  voucherCode: null,
};

export {
  voucherTypeBasicInformationPropTypes,
  voucherTypeBasicInformationDefaultProps,
};
